import { render } from "./Configurations.vue?vue&type=template&id=17c01cda&scoped=true"
import script from "./Configurations.vue?vue&type=script&lang=js"
export * from "./Configurations.vue?vue&type=script&lang=js"

import "./Configurations.vue?vue&type=style&index=0&id=17c01cda&scoped=true&lang=scss"

import exportComponent from "/Users/home/Documents/kevin/ftd_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c01cda"]])

export default __exports__